<template>
  <div :class="['app-left-navigation flex-between', isFullScreen ? 'hide' : '']">
    <div class="left-navigation-bg"></div>
    <!-- <div class="top-apps" @mouseover="showAppsMenu" @mouseout="hideAppsMenu"> -->
    <div class="top-apps" @click="gotoHome" v-if="false">
      <i class="el-icon-s-home"></i>
    </div>
    <!-- 左侧一级菜单 -->
    <div class="menu-list">
      <el-scrollbar class="full-height no-scroll-x hidd-scroll-bar">
        <div style="height: 0">
          <div
            v-for="(item, index) in menuList"
            :key="index"
            :class="[
              'menu-item',
              currentMenuCode.indexOf(item.code) > -1 ? 'active' : '',
              currentHoverIndex === index ? 'hover-item' : '',
            ]"
            @mouseover="showSubMenu(index)"
            @mouseout="hideSubMenu"
          >
            <!-- @mouseout="hideSubMenu" -->
            <i
              :class="['iconfont-new ' + item.icon]"
              v-if="iconTypeNew.indexOf(item.code) != -1"
            ></i>
            <i v-else :class="['iconfont-lunan', item.icon]"></i>
            <p class="text-ellipse" :title="item.name">{{ item.name }}</p>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <!-- 个人快捷面板 -->
    <div
      :class="['apps-menu-area', appsMenuVisible ? 'show' : '']"
      @mouseover="showAppsMenu"
      @mouseout="hideAppsMenu"
    >
      <div class="panel-title">{{ $t("home.label.apptitle") }}</div>
      <div class="apps-list">
        <el-scrollbar class="full-height no-scroll-x">
          <div
            v-for="(item, index) in appMenuList"
            :key="index"
            :class="['apps-item']"
            @click="clickApps(index)"
          >
            <i :class="[$config.fontFamily, item.icon]"></i>
            <p class="text-ellipse" :title="item.name">{{ item.name }}</p>
            <i class="el-icon-close close-icon" @click.stop="deleteApps(index)"></i>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 右侧多级菜单 -->
    <!--  -->
    <div
      class="hover-blur-panel"
      :class="['sub-menu-area', subMenuVisible ? 'show' : '']"
      @mouseover="showSubMenu"
      @mouseout="hideSubMenu"
    >
      <div class="panel-title">
        {{ currentHoverIndex >= 0 ? menuList[currentHoverIndex].name : "" }}
      </div>
      <div class="sub-menu-list">
        <!-- <div class="panel-title" @mouseout.stop="">{{ currentHoverIndex >= 0 ? menuList[currentHoverIndex].name : '' }}</div>
      <div class="sub-menu-list" @mouseout.stop=""> -->
        <el-scrollbar class="full-height no-scroll-x">
          <div style="height: 0">
            <div
              v-for="lineIndex in Math.ceil(currentSubMenu.length / 2)"
              :key="lineIndex"
              class="sub-menu-line"
            >
              <div
                v-if="(lineIndex - 1) * 2 < currentSubMenu.length"
                class="sub-menu-column"
              >
                <p class="sub-menu-name">
                  {{ currentSubMenu[(lineIndex - 1) * 2].name }}
                </p>
                <div
                  v-if="
                    currentSubMenu[(lineIndex - 1) * 2].children &&
                    currentSubMenu[(lineIndex - 1) * 2].children.length
                  "
                >
                  <div
                    v-for="(item, index) in currentSubMenu[(lineIndex - 1) * 2].children"
                    :key="index"
                    class="sub-menu-item flex-between"
                    @click="clickMenu((lineIndex - 1) * 2, index)"
                  >
                    <!-- <i :class="['iconfont-lunan', item.icon]"></i> -->
                    <p class="leaf-menu-name text-ellipse" :title="item.name">
                      {{ item.name }}
                    </p>
                    <i
                      v-if="false"
                      :title="
                        appMenuCodeList.indexOf(item.code) !== -1
                          ? $t('home.message.removeapp')
                          : $t('home.message.addapp')
                      "
                      :class="[
                        $config.fontFamily,
                        appMenuCodeList.indexOf(item.code) !== -1
                          ? 'always-show ioc-Correct'
                          : 'ioc-Favorites',
                        'ioc-tooltip',
                      ]"
                      @click.stop="
                        addFavourite(
                          (lineIndex - 1) * 2,
                          appMenuCodeList.indexOf(item.code) !== -1
                        )
                      "
                    ></i>
                  </div>
                </div>
              </div>
              <div
                v-if="(lineIndex - 1) * 2 + 1 < currentSubMenu.length"
                class="sub-menu-column"
              >
                <p class="sub-menu-name">
                  {{ currentSubMenu[(lineIndex - 1) * 2 + 1].name }}
                </p>
                <div
                  v-if="
                    currentSubMenu[(lineIndex - 1) * 2 + 1].children &&
                    currentSubMenu[(lineIndex - 1) * 2 + 1].children.length
                  "
                >
                  <div
                    v-for="(item, index) in currentSubMenu[(lineIndex - 1) * 2 + 1]
                      .children"
                    :key="index"
                    class="sub-menu-item flex-between"
                    @click="clickMenu((lineIndex - 1) * 2 + 1, index)"
                  >
                    <!-- <i :class="['iconfont-lunan', item.icon]"></i> -->
                    <p class="leaf-menu-name text-ellipse" :title="item.name">
                      {{ item.name }}
                    </p>
                    <i
                      v-if="false"
                      :title="
                        appMenuCodeList.indexOf(item.code) !== -1
                          ? $t('home.message.removeapp')
                          : $t('home.message.addapp')
                      "
                      :class="[
                        $config.fontFamily,
                        appMenuCodeList.indexOf(item.code) !== -1
                          ? 'always-show ioc-Correct'
                          : 'ioc-Favorites',
                        'ioc-tooltip',
                      ]"
                      @click.stop="
                        addFavourite(
                          (lineIndex - 1) * 2 + 1,
                          appMenuCodeList.indexOf(item.code) !== -1
                        )
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import cacheKeys from "@/common/config/cacheKeys";
import menuMap from "@src/common/config/menuMap";
import eventConfig from "@src/common/config/eventConfig";
import eventBus from "@src/common/utils/eventBus";
export default {
  props: {},
  data() {
    return {
      iconTypeNew: ["07", "10", "11", "12", "13"],
      // 快捷菜单面板展示状态： false-不展示；true-展示
      appsMenuVisible: false,
      // 子菜单面板展示状态： false-不展示；true-展示
      subMenuVisible: false,
      // 当前悬停的菜单索引
      currentHoverIndex: -1,
      // 当前激活的一级菜单
      currentMenuIndex: 0,
      // 后台返回的个人快捷菜单code列表
      appMenuCodeList: [],
      // 快捷菜单列表
      appMenuList: [],
      // 主菜单列表
      menuList: [],
      // 主菜单字典
      menuMap: {},
      flatMenu: [],
      sysList: [],
      // 当前激活的子菜单列表
      currentSubMenu: [],
      showMenuList: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    currentPath() {
      return this.$route.path && this.$route.path.split("?")[0];
    },
    currentMenuCode() {
      // console.log(this.$route);
      // console.log(this.flatMenu);
      let menuCode = "";
      let path =
        (this.$route.path && this.$route.path.split("?")[0]) || this.$route.meta.module;
      this.flatMenu.forEach((item) => {
        if (item.path === path) {
          if (item.parentCodes === "-1") {
            menuCode = item.menuCode;
          } else {
            let parentCodesArr = item.parentCodes.split(",");
            menuCode = parentCodesArr[1];
          }
        } else if (
          !item.path &&
          menuMap.MENU[item.menuCode] &&
          menuMap.MENU[item.menuCode].path
        ) {
          if (menuMap.MENU[item.menuCode].path === path) {
            if (item.parentCodes === "-1") {
              menuCode = item.menuCode;
            } else {
              let parentCodesArr = item.parentCodes.split(",");
              menuCode = parentCodesArr[1];
            }
          }
        }
      });
      // console.log("left-navigation=>currentMenuCode:", menuCode);
      return menuCode || "";
    },
    isFullScreen() {
      return this.$store.getters.isFullScreen;
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("sessionMenuData");
    if (this.hideSubMenuTimer) {
      clearTimeout(this.hideSubMenuTimer);
    }
    if (this.hideCoverTimer) {
      clearTimeout(this.hideCoverTimer);
    }
    if (this.hideAppsMenuTimer) {
      clearTimeout(this.hideAppsMenuTimer);
    }
  },
  created() {
    if (window.systemConfig.MENU_STATIC) {
      this.queryMenuByMock();
    } else {
      this.queryMenu();
    }
  },
  mounted() {},
  methods: {
    gotoHome() {
      this.$router.push({
        path: this.$config.HOME_PAGE,
      });
    },
    //递归处理菜单，使其扁平化
    flattenMenu(arr) {
      for (let item of arr) {
        this.flatMenu.push(item);
        if (item.childrens && item.childrens.length > 0) {
          this.flattenMenu(item.childrens);
        }
      }
    },
    queryMenuByMock() {
      // 子菜单列表，主菜单的code作为key，每个子菜单列表为树状结构
      this.subMenuList = {};
      // 获取用户系统菜单列表
      this.$fetch(this.$api.common.getSystemMenus).then((response) => {
        if (response.success) {
          let menuList = response.returnObj;
          if (menuList && menuList.length) {
            menuList.forEach((item) => {
              if (!menuMap.MENU[item.code]) {
                // console.log(item.code, ', not exit')
              }
              this.menuList.push({
                code: item.code,
                name: this.$t(menuMap.MENU[item.code].name),
                icon: menuMap.MENU[item.code].icon,
                path: menuMap.MENU[item.code].path,
              });
              this.subMenuList[item.code] = this.buildSubMenuByMock(item.children);
            });
            this.$log.info("this.menuList,", this.menuList);
            this.$log.info("this.subMenuList,", this.subMenuList);
          }
        }
      });
      // // 获取用户快捷菜单列表
      // this.$fetch(this.$api.common.getUserMenus).then((response) => {
      //   if (response.success) {
      //     this.appMenuCodeList = response.returnObj;
      //     if (this.appMenuCodeList && this.appMenuCodeList.length) {
      //       this.appMenuCodeList.forEach((item) => {
      //         this.appMenuList.push({
      //           code: item,
      //           name: this.$t(menuMap.MENU[item].name),
      //           icon: menuMap.MENU[item].icon,
      //           path: menuMap.MENU[item].path
      //         });
      //       });
      //     }
      //   }
      // })
    },
    queryMenu() {
      // 子菜单列表，主菜单的code作为key，每个子菜单列表为树状结构
      this.subMenuList = {};
      // 加载系统配置-导航菜单加载
      const { account } = this.userInfo;
      // 获取用户系统菜单列表
      let menuAll = {
        returnObj: JSON.parse(sessionStorage.getItem("MENUALL")),
      };
      if (!menuAll.returnObj) {
        this.$fetch(this.$api.common.getMenusByAccount, {
          accountNumber: account,
        }).then((res) => {
          this.dealMenu(res);
        });
      } else {
        this.dealMenu(menuAll);
      }

      // // 获取用户快捷菜单列表
      // this.$fetch(this.$api.common.getUserMenus).then((response) => {
      //   if (response.success) {
      //     this.appMenuCodeList = response.returnObj;
      //     if (this.appMenuCodeList && this.appMenuCodeList.length) {
      //       this.appMenuCodeList.forEach((item) => {
      //         this.appMenuList.push({
      //           code: item,
      //           name: this.$t(menuMap.MENU[item].name),
      //           icon: menuMap.MENU[item].icon,
      //           path: menuMap.MENU[item].path
      //         });
      //       });
      //     }
      //   }
      // })
    },
    dealMenu(response) {
      // this.$fetch(this.$api.common.getMenusByAccount, {
      //   accountNumber: account,
      // }).then((response) => {
      // if (response.success) {
      this.allMenuList = [];
      let menuList = [];
      if (response.returnObj && response.returnObj.menuList) {
        response.returnObj.menuList.some((item, index) => {
          // 过滤掉APP菜单
          if (item.menuCode === "97") {
            return response.returnObj.menuList.splice(index, 1);
          }
        });
        menuList = response.returnObj.menuList;
      }
      this.$utils.Cache.put("BTN_PERMISSION", response.returnObj.authorityList);
      if (!menuList.length) {
        this.showMenuList = false;
        let msg =
          null === menuList ? response.msgContent : "您没有任何权限，请联系管理员！";
        this.$message({
          type: "warning",
          message: msg,
        });
        sessionStorage.setItem("isAuth", "false");
      }
      if (menuList && menuList.length) {
        sessionStorage.setItem("isAuth", "true");
        this.showMenuList = true;
        // 处理菜单数据
        this.flattenMenu(menuList);
        menuList.forEach((item) => {
          const code = item.menuCode;
          if (code === "01") {
            return false;
          }
          if (this.sysList.indexOf(item.subsystemId) === -1) {
            this.sysList.push(item.subsystemId);
          }
          const menu = {
            code: code,
            name: item.menuName,
            color: item.color,
            // icon: item.icon,
            icon: menuMap.MENU[item.menuCode] && menuMap.MENU[item.menuCode].icon,
            path:
              item.path ||
              (menuMap.MENU[item.menuCode] && menuMap.MENU[item.menuCode].path),
            subsystemId: item.subsystemId,
            subsystemName: item.subsystemName,
          };
          this.allMenuList.push(menu);
          if (item.subsystemId === this.sysList[0]) {
            this.menuList.push(menu);
          }
          if (item.childrens && item.childrens.length > 0) {
            this.subMenuList[code] = this.buildSubMenu(item.childrens);
          } else {
            this.menuMap[code] = menu;
            this.subMenuList[code] = [];
          }
        });
        this.$log.debug("子菜单列表：", this.subMenuList);
        // console.log(this.subMenuList)
        // this.$store.commit(cacheKeys.MENU_MAP, this.menuMap)
        let sessionMenuData = {
          twoMenu: menuList,
          threeMenu: this.subMenuList,
        };
        sessionStorage.setItem("sessionMenuData", JSON.stringify(sessionMenuData));
        eventBus.emit(eventConfig.MENU_READY, this.menuMap);
        sessionStorage.setItem("sessionMenuMap", JSON.stringify(this.menuMap));
        this.$emit("loadSysMenu", this.sysList);
      }
      // }
      // });
    },
    buildSubMenu(list) {
      let tempList = [];
      if (list && list.length) {
        list.forEach((item) => {
          let tempItem = {
            code: item.menuCode,
            name: item.menuName,
            color: item.color,
            // icon: item.icon,
            path:
              item.path ||
              (menuMap.MENU[item.menuCode] && menuMap.MENU[item.menuCode].path),
            icon: menuMap.MENU[item.menuCode] && menuMap.MENU[item.menuCode].icon,
            // path: menuMap.MENU[item.menuCode].path,
            subsystemId: item.subsystemId,
            subsystemName: item.subsystemName,
          };
          if (this.sysList.indexOf(item.subsystemId) === -1) {
            this.sysList.push(item.subsystemId);
          }
          if (item.childrens && item.childrens.length > 0) {
            tempItem.children = this.buildSubMenu(item.childrens);
          } else {
            let temp = { ...tempItem };
            tempItem.children = [temp];
            this.menuMap[tempItem.code] = tempItem;
          }
          tempList.push(tempItem);
        });
      }
      return tempList;
    },
    buildSubMenuByMock(list) {
      let tempList = [];
      if (list && list.length) {
        list.forEach((item) => {
          if (!menuMap.MENU[item.code]) {
            // console.log(item.code, ', not exit')
          }
          let tempItem = {
            code: item.code,
            color: item.color,
            name: this.$t(menuMap.MENU[item.code].name),
            icon: menuMap.MENU[item.code].icon,
            path: menuMap.MENU[item.code].path,
          };
          if (item.children && item.children.length) {
            tempItem.children = this.buildSubMenuByMock(item.children);
          }
          tempList.push(tempItem);
        });
      }
      return tempList;
    },
    showSubMenu(index) {
      if (
        index >= 0 &&
        ((this.menuList[index] && !this.subMenuList[this.menuList[index].code]) ||
          this.subMenuList[this.menuList[index].code].length === 0)
      ) {
        // console.log('menucode not exit')
        return;
      }
      // if (typeof index === "object") {
      //   this.$log.debug('showMenu by submenu: ');
      // } else {
      //   this.$log.debug('showMenu by parent: ');
      // }
      if (this.hideSubMenuTimer) {
        // this.$log.debug('clearTimeout,hideSubMenuTimer: ');
        clearTimeout(this.hideSubMenuTimer);
      }
      if (this.hideCoverTimer) {
        // this.$log.debug('clearTimeout,hideCoverTimer: ');
        clearTimeout(this.hideCoverTimer);
      }
      if (this.showMenuTimer) {
        clearTimeout(this.showMenuTimer);
      }
      if (index >= 0) {
        this.hoverIndex = index;
      }
      if (this.subMenuVisible) {
        this.$app.AppInstance.showCover();
        this.currentHoverIndex = this.hoverIndex;
        this.currentSubMenu = this.subMenuList[this.menuList[this.hoverIndex].code];
        // this.$log.debug('hoverIndex: ', this.hoverIndex, ', subMenuList: ', this.subMenuList, ', currentSubMenu: ', this.currentSubMenu);
        if (this.currentSubMenu && this.currentSubMenu.length) {
          this.subMenuVisible = true;
        }
        return;
      }
      this.showMenuTimer = setTimeout(() => {
        this.$app.AppInstance.showCover();
        this.currentHoverIndex = this.hoverIndex;
        this.currentSubMenu = this.subMenuList[this.menuList[this.hoverIndex].code];
        // this.$log.debug('hoverIndex: ', this.hoverIndex, ', subMenuList: ', this.subMenuList, ', currentSubMenu: ', this.currentSubMenu);
        if (this.currentSubMenu && this.currentSubMenu.length) {
          this.subMenuVisible = true;
        }
      }, 400);
    },
    hideSubMenu() {
      if (this.hideSubMenuTimer) {
        clearTimeout(this.hideSubMenuTimer);
      }
      if (this.hideCoverTimer) {
        clearTimeout(this.hideCoverTimer);
      }
      if (this.showMenuTimer) {
        clearTimeout(this.showMenuTimer);
      }
      // this.$log.debug('hideSubMenu: ');
      // 因为菜单中的子元素会导致父元素触发mouseout，然后再通过子元素透传mouseover事件
      // 加延时是避免mouseout和mouseover不停的被触发而出现页面闪烁效果
      this.hideSubMenuTimer = setTimeout(() => {
        // this.$log.debug('hideSubMenuTimer: ');
        this.currentHoverIndex = -1;
        this.currentSubMenu = [];
        this.subMenuVisible = false;
      }, 50);
      this.hideCoverTimer = setTimeout(() => {
        // this.$log.debug('hideCoverTimer: ');
        this.$app.AppInstance.hideCover();
      }, 50);
    },
    showAppsMenu() {
      if (this.hideAppsMenuTimer) {
        clearTimeout(this.hideAppsMenuTimer);
      }
      if (this.hideCoverTimer) {
        clearTimeout(this.hideCoverTimer);
      }
      if (this.showMenuTimer) {
        clearTimeout(this.showMenuTimer);
      }
      if (this.subMenuVisible) {
        this.$app.AppInstance.showCover();
        this.appsMenuVisible = true;
        return;
      }
      this.showMenuTimer = setTimeout(() => {
        this.$app.AppInstance.showCover();
        this.appsMenuVisible = true;
      }, 400);
    },
    hideAppsMenu() {
      if (this.hideAppsMenuTimer) {
        clearTimeout(this.hideAppsMenuTimer);
      }
      if (this.hideCoverTimer) {
        clearTimeout(this.hideCoverTimer);
      }
      if (this.showMenuTimer) {
        clearTimeout(this.showMenuTimer);
      }
      this.hideAppsMenuTimer = setTimeout(() => {
        this.appsMenuVisible = false;
      }, 50);
      this.hideCoverTimer = setTimeout(() => {
        this.$app.AppInstance.hideCover();
      }, 50);
    },
    refreshNav(systemId) {
      this.menuList = this.allMenuList.filter((item) => {
        return systemId === item.subsystemId;
      });
      this.$log.info("refreshNav: 当前菜单列表：", this.menuList);
      this.$router.push({ path: this.menuList[0].path });
    },
    clickApps(index) {
      this.$log.info("点击快捷菜单项目，点击索引为：", index);
    },
    deleteApps(index) {
      this.$log.info("删除快捷菜单项目，删除索引为：", index);
    },
    clickMenu(parentIndex, childIndex) {
      this.currentMenuIndex = this.hoverIndex;
      this.$log.info(
        "路由跳转，点击二级菜单索引为：",
        parentIndex,
        "三级菜单索引为: ",
        childIndex
      );
      this.$log.info("当前激活二级菜单: ", this.currentSubMenu);
      // 关闭巡逻任务另开一个网页
      // if (
      //   this.currentSubMenu[parentIndex].children[childIndex].path ===
      //   "/videoPatrol/task"
      // ) {
      //   let newMsg = window.location.href.split("#")[0];
      //   window.open(newMsg + "#/videoPatrol/task");
      // } else {
      this.$router.push(this.currentSubMenu[parentIndex].children[childIndex].path);
      // }

      eventBus.emit(
        eventConfig.MENU_CLICK,
        this.currentSubMenu[parentIndex].children[childIndex]
      );
    },
    addFavourite(index, addFlag) {
      this.$log.info("操作快捷菜单，操作索引为：", index, addFlag);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.app-left-navigation {
  height: 100%;
  width: 100px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 101;
  @include set_animation(all);

  .left-navigation-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(2px);
    // background-color: #fff;
  }

  &.hide {
    width: 0;
    overflow: hidden;
  }

  .top-apps {
    position: relative;
    width: 100%;
    height: 50px;
    cursor: pointer;
    // background-color: #1e2840;
    @include set_theme_color(background-color, left-menu-bg-color);
    display: flex;
    align-items: center;
    justify-content: center;
    @include set_theme_color(color, left-menu-font-color);

    &:hover {
      @include set_theme_color(color, font-active-color);
      // background-color: #1e2840;
    }

    i {
      font-size: 24px;
    }
  }

  .menu-list {
    width: 100%;
    flex: 1;
    // background-color: #407aee;
    background-color: rgba(0, 36, 64, 1);
    // @include set_theme_color(background-color, left-menu-bg-color);
    .menu-item {
      height: 65px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      // @include set_theme_color(color, left-menu-font-color);
      color: #fff;
      @include set_animation(background-color);

      i {
        font-size: 18px;
        line-height: 20px;
      }

      p {
        font-size: 12px;
        width: 100%;
        margin-top: 8px;
        text-align: center;
        padding: 0 5px;
      }

      &.hover-item,
      &:hover {
        // background: rgba(0, 36, 64, 0.5);
        background: rgba(43, 86, 146, 0.4);
        // @include set_theme_color(color, font-active-color);
      }

      &.active {
        // background: rgba(0, 36, 64, 0.5) !important;
        background: rgba(43, 86, 146, 0.4) !important;
        // @include set_theme_color(color, font-active-color);
        // &::before {
        //   content: "";
        //   left: 0;
        //   top: 0;
        //   position: absolute;
        //   height: 100%;
        //   width: 3px;
        //   @include set_theme_color(background-color, active-border-color);
        // }

        // &::after {
        //   content: "";
        //   left: 3px;
        //   top: calc(50% - 5px);
        //   position: absolute;
        //   width: 0;
        //   height: 0;
        //   border: 5px solid;
        //   border-color: transparent transparent transparent;
        //   @include set_theme_color(border-left-color, active-border-color);
        // }
      }
    }
  }

  .sub-menu-area {
    background: #eaf3fd;
    position: absolute;
    width: 0;
    height: 100%;
    left: 100px;
    top: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 5px 0px 30px -10px #40526d;
    @include set_animation(all);

    &.show {
      width: 320px;
    }

    .sub-menu-list {
      flex: 1;
      margin: 0px 40px 20px 45px;

      .sub-menu-line {
        display: flex;
        margin-bottom: 35px;

        .sub-menu-column {
          width: calc((100% - 15px) / 2);

          &:nth-child(2) {
            margin-left: 15px;
          }

          .sub-menu-name {
            font-size: 14px;
            margin: 15px 0 25px;
            color: black;
            // @include set_theme_color(color, font-default-color);
          }

          .sub-menu-item {
            font-size: 12px;
            padding: 8px 0;
            cursor: pointer;

            i {
              font-size: 12px;
              margin-left: 10px;
              width: 14px;
              height: 14px;
              line-height: 14px;
              text-align: center;
              display: none;

              &:hover {
                @include set_theme_color(color, active-border-color);
              }

              &.always-show {
                display: block;
              }
            }

            .leaf-menu-name {
              width: calc(100% - 24px);
              @include set_theme_color(color, left-menu-font-color);
            }

            &:hover {
              // @include set_theme_color(background-color, table-header-bg-color);
              @include set_theme_color(color, main-theme-color);

              .leaf-menu-name {
                @include set_theme_color(color, main-theme-color);
              }

              i {
                display: block;
              }
            }
          }
        }
      }
    }
  }

  .apps-menu-area {
    position: absolute;
    width: 320px;
    height: 0;
    left: 80px;
    top: 0;
    @include set_theme_color(background-color, content-bg-color);
    @include set_theme_color(color, font-active-color);
    z-index: 100;
    display: block;
    overflow: hidden;
    @include set_animation(all);

    &.show {
      height: 540px;
    }

    .apps-list {
      height: 445px;
      margin: 0px 40px 20px 40px;

      .apps-item {
        height: 65px;
        width: 95px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 0 10px 10px 0;
        border: 1px solid;
        cursor: pointer;
        @include set_theme_color(border-color, table-header-bg-color);
        @include set_theme_color(background-color, table-header-bg-color);
        float: left;

        .close-icon {
          position: absolute;
          top: 0px;
          right: 2px;
          font-size: 10px;
          display: none;
        }

        &:hover {
          @include set_theme_color(background-color, active-border-color);
          @include set_theme_color(border-color, main-theme-color);

          .close-icon {
            display: block;
          }
        }

        i {
          font-size: 20px;
          line-height: 20px;
        }

        p {
          width: 100%;
          margin-top: 8px;
          text-align: center;
          padding: 0 5px;
        }
      }
    }
  }

  .panel-title {
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    margin: 25px 30px;
    padding-left: 15px;
    border-left: 2px solid;
    @include set_theme_color(border-left-color, active-border-color);
    @include set_theme_color(color, font-active-color);
  }
}
</style>
